import { CredentialIssuer, CredentialType } from '../Tester/types';

export const types: { label: string; value: CredentialType }[] = [
  {
    label: 'Backflow Certification',
    value: 'BACKFLOW',
  },
  {
    label: 'Cross Connection Certification',
    value: 'CROSS_CONNECTION',
  },
  {
    label: 'Business License',
    value: 'BUSINESS_LICENSE',
  },
];

export const issuers: {
  label: string;
  value: CredentialIssuer;
  types: CredentialType[];
}[] = [
  {
    label: 'State',
    value: 'STATE',
    types: ['BACKFLOW', 'CROSS_CONNECTION', 'BUSINESS_LICENSE'],
  },
  {
    label: 'County',
    value: 'COUNTY',
    types: ['BACKFLOW', 'CROSS_CONNECTION', 'BUSINESS_LICENSE'],
  },
  {
    label: 'City',
    value: 'CITY',
    types: ['BACKFLOW', 'CROSS_CONNECTION', 'BUSINESS_LICENSE'],
  },
  {
    label: 'ABPA',
    value: 'ABPA',
    types: ['BACKFLOW', 'CROSS_CONNECTION'],
  },
  {
    label: 'AWWA',
    value: 'AWWA',
    types: ['BACKFLOW', 'CROSS_CONNECTION'],
  },
  {
    label: 'ASSE',
    value: 'ASSE',
    types: ['BACKFLOW', 'CROSS_CONNECTION'],
  },
  {
    label: 'Water Purveyor',
    value: 'WATER_SUPPLIER',
    types: ['BACKFLOW', 'CROSS_CONNECTION'],
  },
];
